import styled from 'styled-components';

interface InternalContainerProps {
  align?: 'center' | 'flex-start' | 'flex-end';
  justify?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around';
  direction?: string;
  width?: string;
  fullHeight?: boolean;
  padding?: string;
}
export const StyledContainer = styled.div<InternalContainerProps>`
  display: flex;
  padding: ${({padding}) => padding || 0};
  flex-direction: ${({ direction }) => direction || 'row'};
  justify-content: ${({ justify }) => justify || 'flex-start'};
  align-items: ${({ align }) => align || 'flex-start'};
  width: ${({ width }) => width || '100%'};
  height: ${({ fullHeight }) => (fullHeight ? '100%' : 'fit-content')};
`;
